
export default {
    name: "Dashboard",
    data() {
        return {
            message: {
                visible: false,
                type: 'success',
                title: '',
                description: ''
            }
        }
    },

    mounted(){
        this.$on('dashboard-message', function (message) {

            this.message.type = message.type;
            this.message.title = message.title;
            this.message.description = message.description;
            this.message.visible = true;
        })
    },

    methods: {

        onAddUser() {
            this.$router.push('users/new')
        },
        onChangePassword() {
            this.$router.push('users/change-password')
        },

        closeAlert(){
            this.$store.commit('clearDashboardMessage');
        }
    }
}


